import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import TestOrdersTabState from './TestOrdersTabState';
import TestOrdersView from './TestOrdersView';

export default class TestOrdersTabView extends BufferTabView<TestOrdersTabState> {
  render(): this {
    const modelId = this.model.get('modelId');
    ReduxDOMRender.renderToDOM(<TestOrdersView modelId={modelId} />, this.el);
    return this;
  }

  remove(): Backbone.View<TestOrdersTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

TestOrdersTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
